import ReportPage from './ReportPage'

export default function UltimoPrecoEstoqueReport({className = ''}: {className?: string}) {
  return <ReportPage type='ultimo_preco_estoque' className={className} />
}
